import { isValidEmail } from '@monthio/react-components'
import { ValidationResult } from './types'
import i18n from 'i18next'

export const validateEmail = (email: string | undefined): ValidationResult => {
	if (email == '' || email == undefined) {
		return {
			success: false,
			output: i18n.t('validation-fieldRequired'),
		}
	}

	const result = isValidEmail(email)
	if (result.valid) {
		return {
			success: true,
			output: email,
		}
	}

	return {
		success: false,
		output: i18n.t(
			'consumerInputs-personalInformationValidation-validateEmailInvalid-text',
		),
	}
}
